<template>
  <v-app id="Main">
  <Navigation :drawer="drawer" :subMenuDrawer="subMenuDrawer" :showMenu="showMenu"/>
  <NotasFiscais/>
  <v-container :fluid="isConciliacaoManual" :style="styleConciliacaoManual">
      <v-row v-if="!isConciliacaoManual">
        <v-col cols="8" ><ClientSelect :select="(id) => changeGEconomico(id)" v-if="userData.UsuarioTradimus"/><Breadcrumb /></v-col>
        <v-col cols="4"><v-spacer/><UserInfo :userData="userData"/></v-col>
      </v-row>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-container>
  <div v-if="!userData.UsuarioTradimus">
    <vue-widget widget_position="top-right" widget_title="feedback" buttons="#3e5c76" 
    width="400" height="" text_buttons="#ffffff" background="#1d2d44" texts="#fff" timeout="0" 
    width_metric="px" survey_id="67a6162d7fa155be5aceff20" close_button="false" close_permanently="false" 
    response_background="#f0ebd8" hidde_after_answer="true" hidde_when_click_to_close="false" 
    response_font_color="#0a0a0a" font_family="Arial, Helvetica, sans-serif" font_size="large" 
    text_props="{'bold':'false','italic':'false','underline':'false'}" border_radius="0" 
    is_to_post="true" 
    :from='surveyUserData'
    :metadata='surveyMetaData'/>
  </div> 

  <v-btn
  color="rgb(67, 15, 74)"
  fixed
  depressed
  dark
  bottom
  right
  large
  href="https://bionexo.atlassian.net/servicedesk/customer/portal/31"
>
<!-- @click="()=>openMensagem()" -->
<v-icon small class="pr-2" style="color:rgb(207, 212, 3)">fa-comment</v-icon>
<span style="color:rgb(207, 212, 3)">Suporte</span>
</v-btn>
<modal-mensagem-home :dialog="dialog" :fechar="()=>closeMensagem()" ></modal-mensagem-home>
  </v-app>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {conciliacaoClient} from '../libs/conciliacao-client'
import Breadcrumb from "../components/common/Breadcrumb"
import ClientSelect from "../components/common/GrupoEconomicoSelect"
import ModalMensagemHome from "../components/common/modalMensagemHome"
import Navigation from "@/components/common/Navigation"
import UserInfo from "@/components/common/UserInfo"
import NotasFiscais from "../components/nota_fiscal/NotasFiscais"
export default {
  components:{
    Breadcrumb,
    ClientSelect,
    ModalMensagemHome,
    Navigation,
    UserInfo,
    NotasFiscais
  },
  data: () => ({
    dialog: false,
    drawer: true,
    hoje: new Date(),
    limite: new Date(2026,9,9),
    showMenu: true,
    subMenuDrawer: false
  }),
  computed: {
    ...mapState({
      userData: state => state.userData.userData,
    }),
    isConciliacaoManual () {
      const path = this.$route.path
      const isConciliacaoManual = path.includes('conciliacao-manual')
      return isConciliacaoManual
    },
    styleConciliacaoManual () {
      return this.isConciliacaoManual ? 'padding-left: 132px;' : 'padding-left:125px;padding-right:5px;max-width:1280px;'
    },
    surveyUserData() {
      return JSON.stringify({"name": this.userData.Nome, "email": this.userData.Email, "phone":""})
    },
    surveyMetaData() {
      return JSON.stringify({"produto":"Tradimus", "grupo_economico":this.userData.grupo_economico, "tradimus_id":this.userData.Id})
    },
    // exibeNPS(){
    //   return new Date() > new Date(2025, 4, 1) ;
    // }

  },
  beforeMount(){
    if(this.hoje < this.limite){
      this.dialog = true
      //alert(this.hoje + ' | ' + this.limite)
    }
  },
  mounted() {
    Array.from(document.getElementsByTagName("form")).forEach(el => el.setAttribute('autocomplete', 'off'))
    Array.from(document.getElementsByTagName("input")).forEach(el => el.setAttribute('autocomplete', 'new-password'))
    Array.from(document.getElementsByTagName("input")).forEach(el => el.setAttribute('aria-autocomplete', 'list'))
  },
  methods: {
    ...mapActions('permissions', [
      'changeGrupoEconomico'
    ]),
    changeGEconomico(id){
      this.changeGrupoEconomico(id).then(()=>{
        conciliacaoClient.grupoEconomicoId = id
        if(this.$route.path == "/"){
          this.$forceUpdate()
        } else {
          this.$router.push("/")
        }
      })
    },
    closeMensagem(){
      this.dialog=false
    },
    openMensagem(){
      this.$router.route('https://bionexo.atlassian.net/servicedesk/customer/portal/31')
    },
  },
}
</script>
<style>
.nav-menu {
  display: flexbox;
  max-width: 120px !important;
}

.nav-menu.mini {
  max-width: 70px !important;
}

.v-navigation-drawer--mini-variant .v-list-item > *:first-child {
  margin-left: auto;
  margin-right: auto;
}
a.menu-btn {
  display: block;
  margin: 0 auto;
}
.menu-btn,
.menu-btn-label {
  display: block;
  width: 100%;
  text-align: center;
}
#comTomTicketChatWidget {
  min-width: 25px !important;
  }
</style>
